import { motion } from "framer-motion";
import { TrendingUp } from "lucide-react";

const CASES = [
  {
    type: "Ecommerce Brand",
    metric: "+142% ROAS",
    period: "in 90 days",
    bullets: [
      "Rebuilt Meta creative testing from the ground up",
      "New landing page funnel built for conversion",
    ],
  },
  {
    type: "Local Service Business",
    metric: "3.2x booked calls",
    period: "year over year",
    bullets: [
      "Google Search ads aimed at high-intent local buyers",
      "Lead capture and follow-up system installed",
    ],
  },
  {
    type: "SaaS Startup",
    metric: "-38% cost per lead",
    period: "in 60 days",
    bullets: [
      "Positioning sprint sharpened the core message",
      "Paid acquisition paired with email nurture",
    ],
  },
];

export const Results = () => (
  <section data-testid="results-section" className="border-y border-slate-200 bg-white py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-6">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="mb-4 font-mono text-[11px] uppercase tracking-[0.3em] text-kinetic"
      >
        Results
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay: 0.08, ease: [0.22, 1, 0.36, 1] }}
        className="font-display text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl md:text-5xl"
      >
        Proof We Can <span className="text-kinetic">Scale You</span>
      </motion.h2>

      <div className="mt-14 grid gap-5 md:grid-cols-3">
        {CASES.map((c, i) => (
          <motion.article
            key={c.type}
            data-testid={`case-study-card-${i}`}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            className="rounded-2xl border border-slate-200/80 bg-[#FAFAFD] p-8"
          >
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-skybrand">
              {c.type}
            </p>
            <p className="mt-5 font-display text-4xl font-extrabold tracking-tight text-kinetic md:text-5xl">
              {c.metric}
            </p>
            <p className="mt-1 font-mono text-[11px] uppercase tracking-widest text-slate-400">
              {c.period}
            </p>
            <ul className="mt-7 space-y-3">
              {c.bullets.map((b) => (
                <li key={b} className="flex items-start gap-2.5 text-sm leading-relaxed text-slate-600">
                  <TrendingUp size={14} className="mt-0.5 shrink-0 text-skybrand" />
                  {b}
                </li>
              ))}
            </ul>
          </motion.article>
        ))}
      </div>
      <p className="mt-8 font-mono text-[10px] uppercase tracking-widest text-slate-400">
        Representative outcomes — full case studies published at launch
      </p>
    </div>
  </section>
);
